export var HostAddressType;
(function (HostAddressType) {
  HostAddressType["AAAA"] = "AAAA";
  HostAddressType["A"] = "A";
})(HostAddressType || (HostAddressType = {}));